import { observer } from 'mobx-react-lite'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { useThrottledCallback } from 'use-debounce'

import { CallToActionBaseCard } from '../../components/ANewDesign/CallToActionCard/CallToActionBaseCard'
import { DS } from '../../design-system'
import { useStore } from '../../models'
import { events } from '../../models/analytics/analytics-events'

interface LearnPokerProps {
  handleOpenCheatSheet: () => void
  customTitle?: string
}

export const LearnPoker = observer(({ handleOpenCheatSheet, customTitle = 'Hand rankings' }: LearnPokerProps) => {
  const {
    analytics: { setEvent },
    session: { user }
  } = useStore()

  const onOpenCheatSheet = useThrottledCallback(() => {
    handleOpenCheatSheet()
    setEvent(events.homescreen.cheat_sheet, {
      userId: user?._id.toString()
    })
  }, 1000)

  return (
    <View style={{ gap: 16 }}>
      <TouchableOpacity style={styles.handRankings} onPress={onOpenCheatSheet}>
        <DS.Icon name="Key" size={32} color="Global/Black" />
        <DS.Text variant="Heading 3/Medium">{customTitle}</DS.Text>
      </TouchableOpacity>
    </View>
  )
})

export const TableTourCard = ({ onPress }: { onPress: () => void }) => (
  <CallToActionBaseCard
    title="homeScreen.learnPoker"
    buttonText="common.tableTour"
    horizontalBorderColor="#7B043D"
    verticalBorderColor="#FF3ED4"
    onPress={onPress}
  />
)

const styles = StyleSheet.create({
  handRankings: {
    paddingVertical: 16,
    paddingHorizontal: 12,
    gap: 8,
    backgroundColor: 'transparent',
    borderRadius: 40,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey']
  }
})
